import { delete_, get, post, put } from ".";

export const getGroups = () => {
  return get(`/api/admin/user/list`, true);
};
export const getGroupInfo = (groupId) => {
  return get(`/api/admin/group/groupStatisticData/${groupId}`, true);
};
export const getWareHouseAccesses = () => {
  return get(`/api/group/user/getWareHouseAccesses`, true);
};
export const getGroupInfoLeadre = () => {
  return get(`/api/group/group/statisticData`, true);
};
export const getGroupAdminInfo = (groupId) => {
  return get(`/api/admin/user/get/${groupId}`, true);
};
export const getGroupLeaderInfo = (userId) => {
  return get(`/api/group/user/get/${userId}`, true);
};
export const getGroupsActive = () => {
  return get(`/api/admin/trip/getGroupsWhichHasActiveTrip`, true);
};
export const getGroupsUsers = () => {
  return get(`/api/group/user/list`, true);
};
export const getGroupsDrugInArea = () => {
  return get(`/api/jahadgar/drug/list`, true);
};
export const returnDrug = (areaId, drugId, amount) => {
  return put(`/api/region/drug/returnDrug/${areaId}/${drugId}/${amount}`, true);
};
export const countDownEquipment = (areaId, equipmentId, count) => {
  return post(
    `/api/equipment/countDownEquipment/${areaId}/${equipmentId}?count=${count}`,
    true
  );
};
// /api/region/drug/returnDrug/{areaId}/{drugId}/{amount}
export const getAllGroups = () => {
  return get(`/api/admin/group/list`, true);
};
export const getDrugList = () => {
  return get(`/api/jahadgar/drug/list`, true);
};
export const getDrugTypes = () => {
  return get(`/api/drug/getDrugTypes`, true);
};
export const getMyTrips = (filter) => {
  return get(`/api/group/trip/myTrips${filter ? filter : ""}`, true);
};
export const getListEquipment = () => {
  return get(`/api/jahadgar/equipment/list`, true);
};
export const getExternalReferralAccesses = () => {
  return get(`/api/group/user/getExternalReferralAccesses`, true);
};
export const getExternalReferrals = (areaId) => {
  return get(
    `/api/jahadgar/external_referrals/getExternalReferrals/${areaId}`,
    true
  );
};
export const getPatientExternalReferrals = (areaId, patientId) => {
  return get(
    `/api/jahadgar/external_referrals/getPatientExternalReferrals/${areaId}/${patientId}`,
    true
  );
};
export const getPatientExternalReferralsServices = (
  areaId,
  patientId,
  formId
) => {
  return get(
    `/api/jahadgar/external_referrals/getPatientExternalReferralsServices/${areaId}/${patientId}/${formId}`,
    true
  );
};
export const signInGroupUser = (data) => {
  return post(`/api/group/user/signIn`, true, data);
};
export const addToExternalReferralAccesses = (userId) => {
  return post(`/api/group/user/addToExternalReferralAccesses/${userId}`, true);
};
export const postStoreOneDrug = (data) => {
  return post(`/api/drug/store`, true, data);
};
export const postStoreFileDrug = (data) => {
  return post(`/api/drug/batchStore`, true, data);
};
export const postStoreFileEquipment = (data) => {
  return post(`/api/equipment/batchStore`, true, data);
};
export const addWareHouseAccesses = (data) => {
  return post(`/api/group/user/addWareHouseAccesses`, true, data);
};
export const addOneEquipment = (data) => {
  return post(`/api/equipment/store`, true, data);
};
export const updateEquipment = (id, data) => {
  return put(`/api/equipment/update/${id}`, true, data);
};
export const changeStatusGroupLeader = (userId, status) => {
  return put(`/api/group/user/changeStatus/${userId}/${status}`, true);
};
export const addPatientExternalReferralsService = (data) => {
  return put(
    `/api/jahadgar/external_referrals/addPatientExternalReferralsService`,
    true,
    data
  );
};
export const addPatientExternalReferralsServicesFinanceHistory = (
  areaId,
  patientId,
  formId,
  serviceId,
  data
) => {
  return put(
    `/api/jahadgar/external_referrals/addPatientExternalReferralsServicesFinanceHistory/${areaId}/${patientId}/${formId}/${serviceId}`,
    true,
    data
  );
};
export const addPatientExternalReferralsServicesCallHistory = (
  areaId,
  patientId,
  formId,
  serviceId,
  data
) => {
  return put(
    `/api/jahadgar/external_referrals/addPatientExternalReferralsServicesCallHistory/${areaId}/${patientId}/${formId}/${serviceId}`,
    true,
    data
  );
};
export const setPatientExternalReferralsTrackingStatus = (data) => {
  return put(
    `/api/jahadgar/external_referrals/setPatientExternalReferralsTrackingStatus`,
    true,
    data
  );
};
export const updateTrip = (tripId, data) => {
  return put(`/api/group/trip/update/${tripId}`, true, data);
};
export const updateDrug = (drugId, data) => {
  return put(`/api/drug/update/${drugId}`, true, data);
};
export const updateArea = (tripId, data) => {
  return put(`/api/area/update/${tripId}`, true, data);
};
export const revokeExternalReferralAccesses = (userId) => {
  return delete_(
    `/api/group/user/revokeExternalReferralAccesses/${userId}`,
    true
  );
};
export const updatePatient = (patientId, areaId, data) => {
  return put(
    `/api/region/patient/updatePatient/${patientId}/${areaId}`,
    true,
    data
  );
};
export const removeTripFromProject = (projectId, tripId) => {
  return delete_(
    `/api/admin/project/removeTripFromProject/${projectId}/${tripId}`,
    true
  );
};
export const removePatientFromArea = (areaId, patientId) => {
  return delete_(
    `/api/region/patient/removePatientFromArea/${areaId}/${patientId}`,
    true
  );
};
export const removeDrug = (id) => {
  return delete_(`/api/drug/remove/${id}`, true);
};
export const removeEquipment = (id) => {
  return delete_(`/api/equipment/remove/${id}`, true);
};
export const removeAreaFromTrip = (tripId, areaId) => {
  return delete_(`/api/area/removeAreaFromTrip/${tripId}/${areaId}`, true);
};
export const removeFromGroup = (userId) => {
  return delete_(`/api/group/user/removeFromGroup/${userId}`, true);
};
